import { getUserMailboxInfo } from 'owa-client-ids';

export default function getPrimaryAccount(): string {
    return getUserMailboxInfo().userIdentity;
}
